import { render, staticRenderFns } from "./InformCustomer.vue?vue&type=template&id=23c56a04&scoped=true&"
import script from "./InformCustomer.vue?vue&type=script&lang=js&"
export * from "./InformCustomer.vue?vue&type=script&lang=js&"
import style0 from "./InformCustomer.vue?vue&type=style&index=0&id=23c56a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c56a04",
  null
  
)

export default component.exports